<template>
  <div
    v-if="claims && claims.company && claims.company['ROLE_GET_COMPANY']"
    class="dropdown-custom__container"
  >
    <v-btn flat class="dropdown-custom__activator">
      <v-icon color="gray-6">location_city</v-icon>

      <span v-if="company" class="toolbar__button-label hidden-xs-only">
        {{ company.name | ellipsis(25) }}
      </span>

      <span v-else class="toolbar__button-label hidden-xs-only">
        {{ $t('Common.allCompanies') }}
      </span>

      <v-icon color="gray-6" class="hidden-xs-only autocomplete__arrow" right small>keyboard_arrow_down</v-icon>
    </v-btn>

    <v-list v-if="dropdownCompany" class="dropdown-custom__list">
      <v-list-tile>
        <AutoCompleteCompany
          :company="company"
          @resetCompany="clearSelected"
          @change="closeDropdownCompany"
        />
      </v-list-tile>

      <v-list-tile v-if="hasRole('ui', 'UI_ALL_COMPANIES')" class="reset-company">
        <v-list-tile-content>
          <v-list-tile-title @click="clearSelected">
            {{ $t('Common.allCompanies') }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isObject, hasRole } from 'utils/functions'
import AutoCompleteCompany from 'components/AutoCompleteCompany'

export default {
  name: 'DropdownCompany',
  components: {
    AutoCompleteCompany
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims,
      company: ({ company }) => company.selectedCompany
    })
  },
  data () {
    return {
      dropdownCompany: false
    }
  },
  methods: {
    ...mapActions({
      clearSelectedCompany: 'company/clearSelectedCompany'
    }),

    isValidObject (val) {
      return isObject(val)
    },

    hasRole (group, role) {
      return hasRole(group, role)
    },

    dropdownCompanyToogle (event) {
      const getClosest = function (elem, selector) {
        for (; elem && elem !== document; elem = elem.parentNode) {
          if (elem.matches(selector)) return elem
        }
        return null
      }

      const parent = getClosest(event.target, '.dropdown-custom__container')
      if (parent) {
        this.dropdownCompany = true
        return
      }

      this.dropdownCompany = false
    },

    closeDropdownCompany () {
      setTimeout(() => { this.dropdownCompany = false }, 50)
    },

    clearSelected () {
      this.clearSelectedCompany()
      this.closeDropdownCompany()
    }
  },
  mounted () {
    document.addEventListener('click', this.dropdownCompanyToogle, false)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.dropdownCompanyToogle)
  }
}
</script>
